export { routes as memberRoutes } from '../../../member/src/routes/index'
